import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import StillButton from './ui/StillButton';
import { useOverlay } from '../App';
import { useCustomNavigation } from '../hooks/useCustomNavigation';

const ConfirmationOverlay = () => {
    const navigate = useNavigate();
    const { navigateTo } = useCustomNavigation();
    const { starId } = useParams();
    const { toggleOverlay } = useOverlay();
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        toggleOverlay(false);
        
        return () => toggleOverlay(false);
    }, [toggleOverlay]);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 1,
                staggerChildren: 0.5,
            },
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 5 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: {
                duration: 2,
                ease: "easeOut"
            }
        }
    };

    const handleClose = () => {
        navigate('/space');
    };

    const handleCopyId = async () => {
        try {
            await navigator.clipboard.writeText(starId);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const handleViewStar = () => {
        navigateTo(`/view-star/${starId}`);
    };

    return (
        <div className="fixed inset-0 flex flex-col bg-black bg-opacity-40 overflow-y-auto">
            <motion.div 
                className="min-h-screen w-full flex flex-col items-center mt-20 p-4 lg:mt-0 lg:p-8"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.div 
                    className="w-full lg:flex-1 flex flex-col justify-center px-4 lg:p-10 max-w-xl"
                    variants={containerVariants}
                >
                    <motion.div 
                        className="space-y-6"
                        variants={itemVariants}
                    >
                        <div>
                            <h1 className="text-still-pink uppercase mb-2">
                            <span className="text-still-white text-glow-still">Star</span> Created
                            </h1>
                            <p className="text-still-white text-lg lg:text-xl">
                                Your star is now shining. <br/>You can find it any time with this unique ID: 
                                <span className="font-mono text-still-blue block mt-6 mb-8 text-sm">{starId}</span>
                            </p>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
            
            {/* Buttons fixed at the bottom */}
            <motion.div 
                className="fixed bottom-0 left-0 right-0 flex justify-center space-x-4 pointer-events-auto mb-12 sm:mb-16 md:mb-20 lg:mb-24 z-50"
                variants={itemVariants}
            >
                <StillButton 
                    onClick={handleViewStar}
                    aria-label="View Your Star"
                    className="w-auto whitespace-nowrap"
                >
                    VIEW YOUR STAR
                </StillButton>
                <StillButton 
                    onClick={handleClose}
                    aria-label="Close"
                    className="w-auto whitespace-nowrap"
                >
                    CLOSE
                </StillButton>
            </motion.div>
        </div>
    );
};

export default ConfirmationOverlay; 